









import traceQuery from '~/queries/trace.gql'

export default

	data: ->
		loaded: false
		sectionData: {}

	fetch: ->
		@sectionData = await @$craft.getEntry
			query: traceQuery
			variables:
				section: 'trace'
				type: 'recipe'
				slug: 'recipe'

		@loaded = true

	computed:

		recipe: -> @sectionData.recipe?[0]

		block: -> {
			id: @sectionData.id
			backgroundColor: '#18332f'
			buttons: [
				{
					label: 'View Recipe'
					to: @recipe.uri
					color: 'light-green'
					fill: 'solid'
					ariaLabel: 'View Recipe'
					optionalProduct: null
				}
			]
			componentName: 'blocks-half-marquee'
			foregroundImage: []
			icon: []
			image: [
				landscape: @recipe.listingImage
				portrait: []
			]
			layout: 'right'
			showLines: false
			video: null
			videoLabel: null
			videoUrl: null
			copy: [
				"<span class='eyebrow'>Recipe</span>"
				"<h2 class='style-h2'>Feeling inspired?<br>Try this recipe!</h1>"
				"<p>#{@recipe.title}</p>"
			].join ' '
		}

